import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Logo1 from '../assets/Acceptable_photos.png';
import Logo2 from '../assets/unacceptable_photos1v2.png';
import { toast } from 'react-toastify';


import axios from "axios";
import { Navigate, useNavigate } from 'react-router-dom';
import { RegistrationSelect } from '../AllApi/UserApi/UserApi';
import { memberImgPath } from '../AllApi/AdminApi/AdminApi';
import HeaderPage from './HeaderPage';
import UserMasterFooter from '../UserComponents/UserCommonComponent/UserMasterFooter';

const RegSecondPage = (props) => {

      const navigate = useNavigate()

   // Scroll to the top when component is mounted
 useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const [isLoading, setIsLoading] = useState(false); // Add isLoading state
  const [Image, setImage] = useState(null);
  const [BioDataImage, setBioDataImage] = useState(null);
  const data = JSON.parse(sessionStorage.getItem("status"))
   
  const userdata = JSON.parse(sessionStorage.getItem("userdata"));
  const userid=userdata.id
 

  
//   const NewData = (e) => {
//     e.preventDefault();
//     if (!isImageSizeValid) {
//       toast.error("Cannot proceed: Image size exceeds 3 MB", {
//         position: "top-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//       return; // Stop further execution if the image size is invalid
//     }
//     setIsLoading(true)
//       // Check if Image is selected
//   if (!Image || !BioDataImage) {
//     toast.error("Please select an image to upload", {
//       position: "top-right",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//     });
//     return;
//   }
  
  
//     let formData = new FormData();
//     const status="0"
//     formData.append("file", Image);
//     formData.append("file", BioDataImage);
//     formData.append("member_id", userid);
//     // formData.append("image_status",status);


//     const member_id = formData.get("member_id");
//     // const image_status = formData.get("image_status");
//     const file = formData.get("file");
//     for (const entry of formData.entries()) {
     
//     }
   
    
//     const finaldata={
//       member_id:member_id,
//       // image_status:image_status,
//       file:file,
//     }
   
//     axios
//       .post(RegistrationUpload, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       })

//       .then((res) => {
//         setIsLoading(false); 
//         if (res.data.message === "UPDATED") {
//           // alert("File Uploaded Succesfully");
//           toast.success('File Uploaded Succesfully!', {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           sessionStorage.setItem("status", 6);
//           props.onSubmit();

//         }
//       })
//       .catch((err) => {
//         setIsLoading(false);
//         // alert("Failed to upload, try again");
//         toast.error('Failed to upload, try again', {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//         console.log(err);
//       });
//   };

//   const updatedata=()=>{
//     if (!isImageSizeValid) {
//       toast.error("Cannot proceed: Image size exceeds 3 MB", {
//         position: "top-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//       return; // Stop further execution if the image size is invalid
//     }

//     setIsLoading(true)
//     let formData = new FormData();
//     const status="0"
//     formData.append("file", Image);
//     formData.append("member_id", userid);
//     // formData.append("image_status",status);


//     const member_id = formData.get("member_id");
//     // const image_status = formData.get("image_status");
//     const file = formData.get("file");
//     for (const entry of formData.entries()) {
     
//     }
   
    
//     const finaldata={
//       member_id:member_id,
//       // image_status:image_status,
//       file:file,
//     }
   
//     axios
//       .post(RegistrationUpload, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       })

//       .then((res) => {
//         setIsLoading(false);
//         if (res.data.message === "UPDATED") {
//           // alert("File Uploaded Succesfully");
//           toast.success('File Uploaded Succesfully', {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
          
//         }
//       })
//       .catch((err) => {
//         setIsLoading(false);
//         // alert("Failed to upload, try again");
//         toast.error('Failed to upload, try again', {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
        
//         console.log(err);
//       });


//   }

const NewData =(e)=>{
       e.preventDefault();
       navigate('/RegThirdPage');
}

  const [update, setUpdate] = useState(false)
  const [updateimage, setupdateimage] = useState(false)
  //Get Api Call

  const [isEditing, setIsEditing] = useState(false);
 

  const handleEditClick = () => {
   
    
    setIsEditing(true);
    setUpdate(true)
  };
  const [userStatus, setUserStatus] = useState(null)




  const getdata = () => {

    

    axios
      .get(`${RegistrationSelect}${userid}`)
      .then((res) => {

        if (res.data.json !== null) {

          const api = res.data
          api.map((api, index) => {
            setImage(api.image)
           
          })
          setIsEditing(false)
          setupdateimage(true)
          setUpdate(true)
        }
      })
      .catch((error) => {
        // alert("failed to fetch data");
      });
  };
  useEffect(() => {
    setUserStatus(data)
    if (data >5) {
      getdata()
    }

  }, [data])
 

 const seedata =()=>{
  if(data == 9){
    navigate('/mainpage')
  }
  else{
  navigate('/payment')
  } 
}
   
// const setImgfun=(e)=>{
//   setupdateimage(false)
//   setImage(e.target.files[0])
// }

const [isImageSizeValid, setIsImageSizeValid] = useState(true);

const setImgfun = (e) => {
  const file = e.target.files[0];
  if (file) {
    // Check if file size exceeds 3 MB
    if (file.size > 3 * 1024 * 1024) { 
      setIsImageSizeValid(false);
      toast.error("Image size should not exceed 3 MB", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      setIsImageSizeValid(true);
    }
    setImage(file); // Update image state
    setupdateimage(false); // Reset update image state
  }
};
const setBioDataImgfun = (e) => {
  const file = e.target.files[0];
  if (file) {
    // Check if file size exceeds 3 MB
    if (file.size > 3 * 1024 * 1024) { 
      setIsImageSizeValid(false);
      toast.error("Image size should not exceed 3 MB", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      setIsImageSizeValid(true);
    }
    BioDataImage(file); // Update image state
    setupdateimage(false); // Reset update image state
  }
};



  return (
  <>
    
  <div className='p-0'>
   <HeaderPage/>
  <Container className='p-0 py-5'>

  <div className='pe-5 ' style={{ display: "flex", justifyContent: "end" }}>
    {

      userStatus >5
        ? (<button
          className='rounded mt-0' style={{ padding: "7px 16px", backgroundColor: "rgb(233, 224, 227)", border: "0px", color: "rgb(134, 28, 18)", marginBottom:"15px",marginTop:"-24px", fontSize: "20px" }} onClick={handleEditClick}> <b>Edit</b></button>

        ) : null
    }
  </div>

    <div className='rounded shadow p-2 p-lg-5' style={{backgroundColor:"#fcc6b5"}}>
      <Row>
        <Form  onSubmit={NewData} encType="multipart/form-data">

         <Row style={{ paddingTop: "10px" }}>
                            <Col>
                            <div
                                style={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingBottom: "10px",
                                borderBottom: "1px solid gray",
                                color: "rgb(134, 28, 18)",
                                }}
                            >
                                <h5>
                                <b>Upload Your Photo</b>
                                </h5>
                            </div>
                            </Col>
                        </Row>
        
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
             
              
              <div  className='pt-3'>

                <div className="pb-3" style={{display:"flex",justifyContent:"center"}}>
                    <b style={{color:"rgb(134, 28, 18)"}}>(Admin reserves the right to approve/reject the photos)</b>
                </div>

                {/* <Row className='p-3'>

                <Col sm={12} md={4} className="pt-2 text-center">
                <Card className='text-center' style={{ width: '13rem' , border:"0px",height:"12rem" }}>
                  <Card.Img variant="top" loading="lazy" src={updateimage ? `${memberImgPath}/${Image}`: (Image ? URL.createObjectURL(Image) : '') }  style={{ height: '8rem'}} />
                  <Card.Body>
                    <Card.Text className='text-center'>
                    <span>Uploaded Image </span>
                    </Card.Text>
                  </Card.Body>
                </Card>
                </Col>   
                

                <Col sm={12} md={4} className="pt-2" style={{border:"1px solid red"}}>
                <Card className='both text-center' style={{ border:"0px" ,height:"14rem" }}>
                  <Card.Img variant="top" className='acceptable text-center' src={Logo1}  />
                  <Card.Body>
                    <Card.Text className='text-center'>
                      <b style={{fontSize:"17px"}}>This is acceptable</b>
                      <p style={{color:"rgb(0, 247, 0)",fontSize:"45px"}}><b><i class="fa-solid fa-check"></i></b></p>
                    </Card.Text>
                  </Card.Body>
                </Card>
                </Col>

                
                <Col sm={12} md={4} className="pt-3 pt-md-2" style={{border:"1px solid red"}}>
                <Card className='text-center' style={{ width: '300px' , border:"0px",height:"200px" }}>
                  <Card.Img variant="top" className='unacceptable text-center'  src={Logo2} />
                  <Card.Body>
                    <Card.Text className='text-center'>
                      <b style={{fontSize:"17px"}}>This is not acceptable </b>
                      <p style={{color:"red",fontSize:"45px",lineHeight:"0px",}}><b><i class="fa-solid fa-xmark"></i></b></p>
                    </Card.Text>
                  </Card.Body>
                </Card>
                </Col>

                </Row> */}

        <Row className="row p-0 m-0">
          {/* Uploaded Image */}
          {/* <Col sm={12} md={4} className="pt-2">
            <div className="image-box" style={{ width: "13rem" }}>
              <div className="image-container">
                <img
                  src={updateimage ? `${memberImgPath}/${Image}` : (Image ? URL.createObjectURL(Image) : '')}
                  alt="Uploaded"
                  loading="lazy"
                />
              </div>
              <div className="image-label">Uploaded Image</div>
            </div>
          </Col>

          <Col sm={12} md={4} className="pt-2">
            <div className="image-box" style={{ width: "13rem" }}>
              <div className="image-container">
                <img
                  src={updateimage ? `${memberImgPath}/${Image}` : (Image ? URL.createObjectURL(Image) : '')}
                  alt="Uploaded"
                  loading="lazy"
                />
              </div>
              <div className="image-label">Uploaded Image</div>
            </div>
          </Col> */}

          {/* Acceptable Image */}
          {/* <Col sm={12} md={4} className="pt-2 text-center">
            <div className="image-box mx-auto" style={{ width: "100%" }}>
              <div className="image-container">
                <img src={Logo1} alt="Acceptable" />
              </div>
              <div className="image-label">
                <div>This is acceptable</div>
                <div style={{ color: "green", fontSize: "30px" }}>
                  <i className="fa-solid fa-check"></i>
                </div>
              </div>
            </div>
          </Col> */}

          {/* Unacceptable Image */}
          {/* <Col sm={12} md={4} className="pt-2 text-center">
            <div className="image-box mx-auto" style={{ width: "100%" }}>
              <div className="image-container">
                <img src={Logo2} alt="Not Acceptable" />
              </div>
              <div className="image-label">
                <div>This is not acceptable</div>
                <div style={{ color: "red", fontSize: "30px" }}>
                  <i className="fa-solid fa-xmark"></i>
                </div>
              </div>
            </div>
          </Col> */}
        </Row>



              </div>

              <div className='row p-0 m-0 pt-2 '>
                    <div className='col-12 col-md-2'></div>
                    <div className='col-12 col-md-4'>
                     <label htmlFor="img">Upload Image</label>
                    <Form.Control
                            type="file" 
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => setImgfun(e)}
                            // required
                            name="file"
                          />
                    </div>
                    <div className='col-12 col-md-4'>
                    <label htmlFor="img">Upload Bio Data</label>
                    <Form.Control
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => setBioDataImgfun(e)}
                            // required
                            name="file"
                          />
                    </div>
                     <div className='col-12 col-md-2'></div>
              </div>      

            </Form.Group>

            <div style={{ display: 'flex', justifyContent: 'end', }}>
              {!update ? (
                <button className='rounded py-1 px-2 shadow' type='submit'  disabled={isLoading}
                      style={{
                        backgroundColor: 'orangered',
                        border: '0px',
                        color: 'white',
                        fontSize: '20px',
                      }}>
                  {isLoading ? 'Saving...' : 'Save'}
                </button>
              ) : (
                {/* <button className='btn btn-save shadow' type='button' onClick={updatedata}  disabled={isLoading}
                style={{
                        backgroundColor: 'rgb(134, 28, 18)',
                        border: '0px',
                        color: 'white',
                        fontSize: '20px',
                      }}>
                  {isLoading ? 'Updating...' : 'Update'}
                </button> */}
              )}
            </div>

        </Form>
      </Row>      
    </div>
   
          <div  style={{ display: "flex", justifyContent: "end" }}>
            { update === true ? (
              <button onClick={seedata} className='rounded mb-0' style={{ padding: "7px 16px", backgroundColor: "rgb(233, 224, 227)", border: "0px", color: "rgb(134, 28, 18)", marginTop:"20px",marginBottom: "-22px", fontSize: "20px" }} > <b>See Data</b></button>
            ): null
            }
          </div>

  </Container>
  <UserMasterFooter/>
  </div>
  </>
  )
}

export default RegSecondPage




